export class SocialUserInfo {

  constructor(id: number, name: string, email: string, photoUrl: string, firstName: string, lastName: string
            , authToken: string, provider: string, idToken: string, memberType: number, corpType: number, isClaim: boolean) {
    this.Id = id;
    this.Name = name;
    this.Email = email;
    this.PhotoUrl = photoUrl;
    this.FirstName = firstName;
    this.LastName = lastName;
    this.AuthToken = authToken;
    this.Provider = provider;
    this.IdToken = idToken || authToken;
    this.MemberType = memberType;
    this.CorpType = corpType;
    this.IsClaim = isClaim;
  }

  public Id: number;
  public Name: string;
  public Email: string;
  public PhotoUrl: string;
  public FirstName: string;
  public LastName: string;
  public AuthToken: string;
  public Provider: string;
  public IdToken: string;
  public MemberType: number;
  public CorpType: number;
  public IsClaim: boolean;
}
